import { t } from "@/i18n-js/instance";
import type { CurrentCommunity } from "@/react/types/CurrentCommunity";
import { Typography } from "@circle-react-uikit/Typography";
import { CommunityImage } from "../../OnboardingComponents/CommunityImage";

interface AuthenticationTitleProps {
  currentCommunity: CurrentCommunity;
  otpType: "authentication" | "verification";
}

export const AuthenticationTitle = ({
  currentCommunity,
  otpType,
}: AuthenticationTitleProps) => (
  <div className="flex flex-col space-y-1.5 p-6 pb-8 pt-0 text-center">
    <div className="mb-2">
      <CommunityImage
        community={currentCommunity}
        withCircleBranding={!currentCommunity}
        displayCommunityName={false}
      />
    </div>
    <div
      className="mb-1 font-semibold tracking-tight"
      style={{ letterSpacing: "0.01em" }}
    >
      <Typography.TitleLg>
        {t(`otp_challenge_modal.new.${otpType}.title`)}
      </Typography.TitleLg>
    </div>
    <Typography.BodyMd color="text-slate-500">
      {t(`otp_challenge_modal.new.${otpType}.subtitle`)}
    </Typography.BodyMd>
  </div>
);
